import * as types from './mutation-types'

export default {
    [types.LOAD_WITHDRAWAL_PLANNER_ENUMS] (state, enums) {
        state.withdrawalPlannerEnums = enums
    },
}
